<div class="card hover-show w-100 overflow-auto h-100 d-flex flex-column">
    <div class="card-body flex-grow-1 d-flex flex-column">
        <div class="pointer">
            <div [routerLink]="'/organisation/' + linkedContract.entity.organisation.organisationId"
                 class="text-center mb-3">
                <h2 class="card-title notranslate">{{ linkedContract.entity.organisation.info.name }}</h2>
            </div>
            <hr class="card-divider mb-0">
            <ul class="list-group-flush mb-n3 list-group flex-grow-1">
                <li class="list-group-item py-3" *ngFor="let contract of linkedContract.linkedContracts">
                    <div class="row">
                        <div class="col-auto">
                            <i class="bi me-1 bi-calendar"></i>
                        </div>
                        <div class="col text-truncate notranslate hover-show text-muted">
                            <small>
                                <app-contract-range [dateRange]="contract.dateRange" [isReadOnly]="true"></app-contract-range>
                            </small>
                        </div>
                        <div class="col-auto my-3" *ngIf="appContext.isAdminOrIntermediary()">
                            <button type="button" class="btn position-absolute top-0 end-0 to-show" style="right: 24px !important;"
                                    (click)="openLinkContractModal(contract, linkedContract.entity.organisation)">
                                <i class="bi bi-pencil"></i>
                            </button>
                        </div>
                        <div class="col-auto my-3">
                            <app-confirmation-toggle *ngIf="appContext.isAdminOrIntermediary()">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h3 class="modal-title">Remove contract</h3>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <p>Are you sure you want to remove this contract from this organisation?</p>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                                (click)="unlinkContractFromOrganisation(contract, linkedContract.entity.organisation)">
                                            Remove contract
                                        </button>
                                    </div>
                                </div>
                                <button type="button" class="btn position-absolute top-0 end-0 to-show"
                                        role="button" aria-expanded="false">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </app-confirmation-toggle>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <hr class="card-divider mb-0">
        <div *ngIf="appContext.isAdminOrIntermediary()" class="list-group-item py-3 pointer hover-underline mt-auto"
             (click)="linkContractToOrganisation(linkedContract.entity.organisation)">
            <div class="row">
                <div class="col-auto">
                    <i class="bi me-2 bi-plus-circle"></i>
                </div>
                <div class="col text-truncate">
                    <small>Add period</small>
                </div>
            </div>
        </div>
    </div>
</div>